/* eslint-disable */

import AccessesServices from "@/services/api/accesses.services";
import TeamsService from "@/services/api/teams.services";
// import store from "@/store";
// import store from "@/store";


const state = {

  result_access: [],
  result_questions: []
}

const mutations = {
  SET_RESULT_ACCESS(state, payload) {
    state.result_access = payload
  },
  SET_RESULT_QUESTIONS(state, payload) {
    state.result_questions = payload
  }

}

const actions = {



    getResultAccess({ commit }) {
        return new Promise((resolve, reject) => {
          AccessesServices.get('getResultAccess')
                .then((response) => {
                    commit('SET_RESULT_ACCESS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  getAccessQuestions({ commit }) {
        return new Promise((resolve, reject) => {
          AccessesServices.get('getAccessQuestions')
                .then((response) => {
                    commit('SET_RESULT_QUESTIONS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

  setViewRoles({commit}, payload) {
    return new Promise((resolve, reject) => {
      AccessesServices.setViewRoles(
        payload
      )
        .then((response) => {
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

  setQuestionRoles({commit}, payload) {
    return new Promise((resolve, reject) => {
      AccessesServices.setQuestionRoles(
        payload
      )
        .then((response) => {
          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },

}

const getters = {

    getResultAccess: (state) => state.result_access,
    getResultQuestions: (state) => state.result_questions,




}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
